module.exports = __webpack_public_path__ + "img/_4.9f612ac6.png";